import React from 'react';
import { Building2, User } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import MaitresOuvrageRecents from '../../components/MaitresOuvrageRecents';
import PieceIdentiteMO from './PieceIdentiteMO';

export const maitreOuvrageIdentifie = (mo) => !!mo?.type && (
  mo.type === 'professionnel' ? !!mo.raison_sociale?.trim() : !!mo.nom?.trim() && !!mo.prenom?.trim()
);

const Champ = ({ id, label, value, onChange, placeholder, type = 'text' }) => (
  <div className="space-y-1">
    <Label className="text-xs font-semibold text-slate-600">{label}</Label>
    <Input type={type} value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
      className="h-10 text-sm" data-testid={`mo-${id}-input`} />
  </div>
);

/** Identification du maître d'ouvrage (mode nominatif) — obligatoire pour générer le devis. */
export default function MaitreOuvrageBloc({ value, onChange, membreId }) {
  const mo = value || {};
  const set = (k) => (v) => onChange({ ...mo, [k]: v });
  const pro = mo.type === 'professionnel';
  const ok = maitreOuvrageIdentifie(mo);
  return (
    <div className={`space-y-3 rounded-xl border-2 p-4 ${ok ? 'border-emerald-200 bg-emerald-50/40' : 'border-amber-300 bg-amber-50/50'}`} data-testid="mo-bloc">
      <div>
        <h4 className="text-sm font-semibold text-[#0a3d62]">Identification du maître d'ouvrage <span className="text-rose-600">*</span></h4>
        <p className="text-xs text-slate-500">Obligatoire pour le devis nominatif — repris automatiquement dans le workflow de souscription.</p>
      </div>
      <MaitresOuvrageRecents membreId={membreId} onChoisir={(mo) => onChange({ ...mo })} />
      <div className="grid grid-cols-2 gap-2">
        {[['professionnel', 'Professionnel', Building2], ['particulier', 'Particulier', User]].map(([t, l, Icon]) => (
          <button key={t} type="button" onClick={() => onChange({ ...mo, type: t })}
            className={`flex items-center justify-center gap-2 rounded-lg border-2 px-3 py-2 text-sm font-semibold transition-colors ${mo.type === t ? 'border-[#0a3d62] bg-[#0a3d62] text-white' : 'border-slate-200 bg-white text-slate-600 hover:border-[#0a3d62]/40'}`}
            data-testid={`mo-type-${t}`}>
            <Icon className="h-4 w-4" /> {l}
          </button>
        ))}
      </div>
      {mo.type && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {pro && <Champ id="raison-sociale" label="Raison sociale *" value={mo.raison_sociale} onChange={set('raison_sociale')} placeholder="Nom de l'entreprise" />}
          {pro && <Champ id="siret" label="SIRET" value={mo.siret} onChange={set('siret')} placeholder="123 456 789 00012" />}
          <Champ id="nom" label={pro ? 'Nom du représentant' : 'Nom *'} value={mo.nom} onChange={set('nom')} placeholder="Dupont" />
          <Champ id="prenom" label={pro ? 'Prénom' : 'Prénom *'} value={mo.prenom} onChange={set('prenom')} placeholder="Jean" />
          <div className="sm:col-span-2"><Champ id="adresse" label="Adresse" value={mo.adresse} onChange={set('adresse')} placeholder="Numéro et rue" /></div>
          <Champ id="code-postal" label="Code postal" value={mo.code_postal} onChange={set('code_postal')} placeholder="97100" />
          <Champ id="ville" label="Ville" value={mo.ville} onChange={set('ville')} placeholder="Basse-Terre" />
          <Champ id="telephone" label="Téléphone" value={mo.telephone} onChange={set('telephone')} placeholder="0590 XX XX XX" />
          <Champ id="email" label="E-mail" type="email" value={mo.email} onChange={set('email')} placeholder="contact@exemple.fr" />
          <div className="sm:col-span-2"><PieceIdentiteMO mo={mo} membreId={membreId} onChange={onChange} /></div>
        </div>
      )}
      {!ok && <p className="text-xs font-semibold text-amber-700" data-testid="mo-incomplet">Renseignez le type puis {pro ? 'la raison sociale' : 'le nom et le prénom'} pour pouvoir générer le devis.</p>}
    </div>
  );
}
